module.exports = __webpack_public_path__ + "img/airtke_ai.f3232d56.jpg";